module.exports = __webpack_public_path__ + "media/images/default/lp_top_capture_file3-5045882375563310eb0b2eece32a5b36.svg";